import { updateKeyInStore } from 'App';
import * as Yup from 'yup';
import { GeneralStateValues, updateKey } from './slice';

export const fields: IBaseField<keyof GeneralStateValues>[] = [
  {
    name: 'doYouHaveWageIncomeieAJob',
    label: 'Do you have wage income (Ie a job)?',
    type: 'radio',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
  },
  {
    name: 'iHaveAPension',
    label: 'I have a pension',
    type: 'radio',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
  },
  {
    name: 'doYouReceiveAnyDividends',
    label: 'Do you receive any dividends?',
    type: 'radio',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
  },
  {
    name: 'doYouHaveInterestIncome',
    label: 'Do you have interest income?',
    type: 'radio',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
  },
];

export const validationSchema = Yup.object().shape({});
